export const environment = {
  production: true,
  urlEnvioMail: 'https://desarrollo.hatch.com.ar:8443/enviar-email'
};
